import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import styles from './Description.module.scss';

export const Description: React.FC<{ text?: string }> = ({ text }) => {
  const { t } = useTranslation();

  if (!text) {
    return null;
  }

  return (
    <tr key="lotteryDescription">
      <td className={styles['heading']}>
        <Text>{t('general-lottery-description')}</Text>
      </td>
      <td>
        <Text className={styles['description-text']}>{text}</Text>
      </td>
    </tr>
  );
};
